import styled from '@emotion/styled';
import { css } from 'emotion';

export const Container = styled.svg`
  font-weight: bold;
  user-select: none;
  overflow: visible;
`;

export const hiddenChipTextClassName = css`
  position: absolute;
  visibility: hidden;
  pointer-events: none;
`;
